import { useState } from 'react';
import { supabase } from '../supabaseClient';
import { irisError } from '../errors';
import ThemeToggle from './ThemeToggle';

function GoogleLogo() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
      <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
      <path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853"/>
      <path d="M3.964 10.707A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.707V4.961H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.039l3.007-2.332z" fill="#FBBC05"/>
      <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.961L3.964 6.293C4.672 4.166 6.656 3.58 9 3.58z" fill="#EA4335"/>
    </svg>
  );
}

export default function Login({ isDark, onToggleTheme }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleGoogle() {
    setError('');
    setLoading(true);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: `${window.location.origin}${window.location.pathname || '/'}`,
        skipBrowserRedirect: false,
      },
    });
    if (error) {
      setError(irisError('IRIS-104', error.message));
      setLoading(false);
    }
  }

  return (
    <div style={styles.page}>
      <div style={{ position: 'absolute', top: 16, right: 16 }}>
        <ThemeToggle isDark={isDark} onToggle={onToggleTheme} />
      </div>
      <div style={styles.card}>
        <h1 style={styles.brand}>Iris Digital Consulting</h1>
        <p style={styles.sub}>Client Portal</p>
        {error && <p style={styles.error}>{error}</p>}
        <button
          onClick={handleGoogle}
          disabled={loading}
          style={styles.button}
        >
          <GoogleLogo />
          {loading ? 'Redirecting…' : 'Continue with Google'}
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'var(--bg)',
    fontFamily: "'DM Sans', system-ui, sans-serif",
  },
  card: {
    background: 'var(--bg-surface)',
    border: '1px solid var(--border)',
    borderRadius: 12,
    padding: '48px 40px',
    width: 360,
    maxWidth: '90vw',
  },
  brand: {
    fontSize: 20,
    fontWeight: 700,
    color: 'var(--text)',
    margin: '0 0 4px 0',
    letterSpacing: '-0.3px',
    fontFamily: "'Syne', system-ui, sans-serif",
  },
  sub: {
    fontSize: 13,
    color: 'var(--text-dim)',
    margin: '0 0 32px 0',
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    width: '100%',
    padding: '11px 16px',
    background: '#fff',
    color: '#3c4043',
    border: 'none',
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 500,
    cursor: 'pointer',
    fontFamily: "'DM Sans', system-ui, sans-serif",
    boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
    transition: 'box-shadow 0.15s',
  },
  error: { fontSize: 13, color: 'var(--danger)', margin: '0 0 16px 0' },
};
